<mat-card>
    <mat-card-header>
        <mat-card-title>Additional Info - {{ teamName }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-form-field appearance="fill" floatLabel="always" [hideRequiredMarker]="true">
            <mat-label>Team Notes:</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10" [readonly]="true">{{ teamNotes }}</textarea>
        </mat-form-field>
        <mat-form-field *ngFor="let player of playerList" appearance="fill" floatLabel="always" [hideRequiredMarker]="true">
            <mat-label>{{ player.name }}:</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10" [readonly]="true">{{ player.notes }}</textarea>
        </mat-form-field>
    </mat-card-content>
</mat-card>